import { Injectable } from '@angular/core';
import { GoogleTagManagerConstants } from '../constants/constants';
import { sendGoogleTagManagerEvent } from '../helpers/helper';
import { DataLayerKeyValuePairs } from '../helpers/helper';

@Injectable({ providedIn: 'root' })
export class SessionTrackingService {
  private readonly SESSION_ID_KEY = 'xp_session_id';
  private readonly SESSION_START_KEY = 'xp_session_start';
  private readonly SESSION_LAST_MODULE_KEY = 'xp_last_module';

  startSession(): void {
    const sessionId = Date.now();
    const entryUrl = window.location.href;

    sessionStorage.setItem(this.SESSION_ID_KEY, String(sessionId));
    sessionStorage.setItem(this.SESSION_START_KEY, String(sessionId));
    sessionStorage.setItem(this.SESSION_LAST_MODULE_KEY, entryUrl);

    sendGoogleTagManagerEvent(
      [GoogleTagManagerConstants.CustomTriggerEvents.SessionStarted],
      [
        [GoogleTagManagerConstants.DataLayerVars.SessionID, sessionId],
        [GoogleTagManagerConstants.DataLayerVars.EntryURL, entryUrl],
        [GoogleTagManagerConstants.DataLayerVars.LastActiveModule, entryUrl],
      ],
    );
  }

  endSession(): void {
    const sessionId = Number(sessionStorage.getItem(this.SESSION_ID_KEY));
    if (!sessionId) return;

    const startTime = Number(sessionStorage.getItem(this.SESSION_START_KEY));
    const lastActiveModule = sessionStorage.getItem(this.SESSION_LAST_MODULE_KEY) ?? window.location.href;
    const exitUrl = window.location.href;
    const elapsedSeconds = Math.round((Date.now() - startTime) / 1000);
    const sessionDuration = elapsedSeconds < 60
      ? `${elapsedSeconds}s`
      : `${Math.round(elapsedSeconds / 60)}m`;

    sessionStorage.removeItem(this.SESSION_ID_KEY);
    sessionStorage.removeItem(this.SESSION_START_KEY);
    sessionStorage.removeItem(this.SESSION_LAST_MODULE_KEY);

    sendGoogleTagManagerEvent(
      [GoogleTagManagerConstants.CustomTriggerEvents.SessionEnded],
      [
        [GoogleTagManagerConstants.DataLayerVars.SessionID, sessionId],
        [GoogleTagManagerConstants.DataLayerVars.exitUrl, exitUrl],
        [GoogleTagManagerConstants.DataLayerVars.LastActiveModule, lastActiveModule],
        [GoogleTagManagerConstants.DataLayerVars.SessionDuration, sessionDuration],
      ],
    );
  }

  updateLastActiveModule(url: string): void {
    sessionStorage.setItem(this.SESSION_LAST_MODULE_KEY, url);
  }
}
